import React from "react";
import { Link } from "react-router-dom";
import { getBannerForLesson, PromotionalBannerConfig } from "./bannerConfig";

interface PromotionalBannerProps {
	lessonId: number;
}

const bannerStyle: React.CSSProperties = {
	display: "block",
	width: "100%",
};

const imageStyle: React.CSSProperties = {
	display: "block",
	width: "100%",
	zIndex: 1,
	position: "relative",
};

/**
 * Component that renders promotional banners for specific lessons
 * Banner configuration is stored in bannerConfig.ts
 */
const PromotionalBanner: React.FC<PromotionalBannerProps> = ({ lessonId }) => {
	const bannerConfig = getBannerForLesson(lessonId);

	if (!bannerConfig) {
		return null;
	}

	const { type, href, imageUrl, alt } = bannerConfig;

	if (type === "internal") {
		return (
			<Link to={href} style={bannerStyle} aria-label={alt}>
				<img
					src={imageUrl}
					alt={alt}
					style={imageStyle}
					loading="lazy"
				/>
			</Link>
		);
	}

	return (
		<a
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			style={bannerStyle}
			aria-label={alt}
		>
			<img
				src={imageUrl}
				alt={alt}
				style={{ display: "block", width: "100%" }}
				loading="lazy"
			/>
		</a>
	);
};

export { PromotionalBanner };
export type { PromotionalBannerConfig };
